import { DefineComponent } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { networkDetailResource } from '@services/network.service'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import Receive from '@m/cabinet/components/views/Receive.vue'

import { accessPermission } from '@/modules/user/permissions'
import { IS_DOCTOR } from '@/modules/user/accessTokens'

const CHAIN_PREFIX = 'cabinet:chain'
const p = (name: string) => CHAIN_PREFIX + ':' + name

export const CHAIN_CREATE_VIEW_NAME = p('create')
export const CHAIN_EDIT_VIEW_NAME = p('edit')
export const CHAIN_FACILITIES_VIEW_NAME = p('facilities')

const CreateView = () => import('./views/Create.vue')
const EditView = () => import('./views/Edit.vue')
const FacilitiesView = () => import('./views/Facilities.vue')

const BASE_MODEL_NAME = 'chain/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  const { app } = options

  return [
    route('create/', CreateView, CHAIN_CREATE_VIEW_NAME, {
      meta: {
        title: () => $t('Setting up a chain'),
      },
    }),

    receiveRoute(
      networkDetailResource,
      [
        route('edit/', EditView, CHAIN_EDIT_VIEW_NAME, {
          meta: {
            title: () => $t('Setting up a chain'),
          },
        }),
        { path: '', redirect: { name: CHAIN_EDIT_VIEW_NAME } },
      ],
      Receive as DefineComponent,
      '',
      'chainId',
      'id'
    ),
    route(':chainId/facilities/', FacilitiesView, CHAIN_FACILITIES_VIEW_NAME, {
      meta: {
        title: () => $t('Medical facilities of chain'),
      },
    }),
    {
      path: '',
      redirect: { name: CHAIN_CREATE_VIEW_NAME },
      name: CHAIN_PREFIX,
    },
  ]
}

export { BASE_MODEL_NAME }
